module.exports = __webpack_public_path__ + "dec72de01f9eccfce96df93ae0d1cd86.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-03-04/whats-new.html
// module id = 2101
// module chunks = 0